import styled from 'styled-components';


const StyledLink = styled.a`
  color: #333;
`

const StyledLinkList = styled.ul<{ align?: 'left' | 'right' }>`
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: row;
  justify-content: ${props => props.align === 'right' ? 'flex-end' : 'flex-start'};

  li {
    margin-right: 16px;

    a {
      color: #333;
      text-decoration: none;

      &:hover {
        text-decoration: underline;
      }
    }
  }

  & li:last-child {
    margin-right: 0;
  }
`;

export { StyledLinkList, StyledLink };